// @ts-check
/** @type {import("../../serverside/types/rz")} */

const rz = {
  /* ============== constants ============== */
  version: "2025-09-10",
  enableConsoleLog: true,
  unknowSpase: String.fromCharCode(160), // "неразрывный пробел" или &nbsp;

  /* ============== Check Types ============== */
  isString: (value) => Boolean(typeof value === "string" || value instanceof String),

  isNumber: (value) => Boolean(typeof value === "number" && Number.isFinite(value)),

  isBoolean: (value) => Boolean(typeof value === "boolean"),

  isBuffer: (value) => Boolean(Buffer.isBuffer(value)),

  isDate: (value) => Boolean(value instanceof Date),

  isArray: (value) => Boolean(value && typeof value === "object" && value.constructor === Array),

  isFunction: (value) => Boolean(typeof value === "function"),

  isPromise: (value) => Boolean(~(((String(value) || "").split("\n")[0]).replace((/\s+/g), "")).indexOf(")=>newPromise(")),

  isObject: (value) => Boolean(value && typeof value === "object" && (value.constructor === Object || value.constructor.name === "model")),

  isUndefinedOrNull: (value) => Boolean(typeof value === "undefined" || value === null),

  isRegExp: (value) => Boolean(value && typeof value === "object" && value.constructor === RegExp),

  canBeRegexp: (str) => (rz.isString(str) && (/^\/.*\/[gimsuy]*$/igm).test(str.trim())),

  isRealValue: (value) => Boolean(value && value !== "null" && value !== "undefined" && value !== ""),

  isError: (value) => Boolean(value instanceof Error),

  numIsInt: (num) => Boolean(Math.round(num) === num),

  canbeNumber: (value) => Boolean(!Number.isNaN(parseFloat(value)) && Number.isFinite(Number(value))),

  isNumeric: (value) => Boolean(typeof value === "string" && (/^[+-]?\d*(\.|,)?\d+(?:[Ee][+-]?\d+)?$/igm).test(value)),

  validatePhone: (phone) => Boolean((/^\+?([0-9]{3,4})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/).test(phone)),

  validateEmail: (email) => Boolean((/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(email)),
  // @ts-ignore
  isStrObjectId: (value) => ((typeof value === "string" || value instanceof String) && (/([a-f]|[0-9]){24,24}/ig).test(value)), // value.length === 24

  /* ============== Web-page ============== */
  /* eslint-disable max-len */
  isMobileDevice: (userAgent) => Boolean(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(userAgent)
  || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(userAgent.slice(0, 3))),
  /* eslint-enable max-len */

  // usefull content width & height
  documentSize: (documnt) => {
    const ans = {width: 0, height: 0, result: false};
    const dcm = documnt || document;
    if (dcm && dcm.documentElement && dcm.documentElement.scrollWidth) { ans.width = dcm.documentElement.scrollWidth; ans.height = dcm.documentElement.scrollHeight; ans.result = true }
    return ans;
  },

  windowSize: (windw) => {
    const ans = {width: 0, height: 0, result: false};
    const wnd = windw || window;
    if (wnd && wnd.innerWidth && wnd.innerHeight) { ans.width = wnd.innerWidth; ans.height = wnd.innerHeight; ans.result = true }
    return ans;
  },

  isClientSide: !(typeof process !== "undefined" && (process.release.name.search(/node|io.js/) !== -1)),

  // @ts-ignore
  detectLng: () => {
    let lng = "en";
    if (~document.title.indexOf("[RU]")) { lng = "ru" }
    else if (~document.title.indexOf("[TR]")) { lng = "tr" }
    return lng;
  },

  /* ============== Objects ============== */
  objToJSON: (sourceObj) => {
    let a;
    try {
      a = JSON.stringify(sourceObj);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      a = null;
    }
    return a;
  },

  objFromJSON: (sourceJSON) => {
    let a;
    try {
      a = JSON.parse(sourceJSON);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      a = null;
    }
    return a;
  },

  objClone: (sourceObj, usingSpreadOperator) => {
    let ans = null;
    if (rz.isDate(sourceObj)) {
      ans = new Date(sourceObj.getTime());
    }
    else if (rz.isBuffer(sourceObj)) {
      ans = sourceObj.slice();
    }
    else if (rz.isArray(sourceObj)) {
      ans = (sourceObj.slice()).map((item) => (rz.objClone(item, usingSpreadOperator)));
    }
    else if (sourceObj && sourceObj.toObject) {
      ans = sourceObj.toObject(); // Mongo-to-Object
    }
    else if (rz.isObject(sourceObj)) {
      if (usingSpreadOperator === true) {
        ans = {...sourceObj};
      }
      else {
        const a = rz.objToJSON(sourceObj); ans = rz.objFromJSON(a);
      }
    }
    else if (rz.isNumber(sourceObj) || rz.isString(sourceObj) || rz.isBoolean(sourceObj)) {
      ans = sourceObj;
    }
    return ans;
  },

  objKeys: (obj) => {
    const ans = [];
    if (!rz.isObject(obj)) return ans;
    Object.keys(obj).forEach((key) => {
      ans.push(key);
    });
    return ans;
  },

  objHasKey: (obj, key) => {
    if (!rz.isObject(obj) || !rz.isString(key)) return false;
    return Boolean(key in obj);
  },

  objByString: (obj, stringPath, preventClone) => {
    const s1 = stringPath.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, ""), a = s1.split(".");
    let o1; if (preventClone) { o1 = obj } else { o1 = rz.objClone(obj) }
    for (let i = 0; i < a.length; i++) {
      if (a[i] in o1) { o1 = o1[a[i]] }
      else { return null }
    }
    return o1;
  },

  objModifyByString: (obj, stringPath, newSection) => {
    const s1 = stringPath.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, ""), a = s1.split(".");
    let o1 = obj, result = true;
    for (let i = 0; i < a.length; i++) {
      if (a[i] in o1) {
        if (i === (a.length - 1)) { o1[a[i]] = newSection } else { o1 = o1[a[i]] }
      } else { result = false; break }
    }
    return result;
  },

  dbFiltersSubstitute: (dbFilter, user) => {
    if (!dbFilter) { return dbFilter }
    let fstr; try { fstr = JSON.stringify(dbFilter) } catch (err) { console.log(err) }
    if (!fstr || !(/"%\D+%"/igm).test(fstr)) { return dbFilter } // Quick ans

    const replaceSpecValue = (val) => {
      if (!user || !user.login || !user.userdata || !user.userdata.length) { return "" }
      if (~val.indexOf("%company%")) { const tg = user.userdata.find((oo) => (oo.key === "company")); if (tg) { return tg.value || "" } }
      else if (~val.indexOf("%title%")) { const tg = user.userdata.find((oo) => (oo.key === "title")); if (tg) { return tg.value || "" } }
      else if (~val.indexOf("%department%")) { const tg = user.userdata.find((oo) => (oo.key === "department")); if (tg) { return tg.value || "" } }
      else if (~val.indexOf("%office%")) { const tg = user.userdata.find((oo) => (oo.key === "office")); if (tg) { return tg.value || "" } }
      else if (~val.indexOf("%city%")) { const tg = user.userdata.find((oo) => (oo.key === "city")); if (tg) { return tg.value || "" } }
      else if (~val.indexOf("%region%")) { const tg = user.userdata.find((oo) => (oo.key === "region")); if (tg) { return tg.value || "" } }
      else if (~val.indexOf("%description%")) { const tg = user.userdata.find((oo) => (oo.key === "description")); if (tg) { return tg.value || "" } }
      return "";
    };
    const processNextKey = (obj) => {
      if (rz.isObject(obj)) {
        const keys = rz.objKeys(obj);
        (keys || []).forEach((kk) => {
          if (rz.isString(obj[kk]) && obj[kk].startsWith("%") && obj[kk].endsWith("%")) { obj[kk] = replaceSpecValue(obj[kk]) }
          else if (rz.isObject(obj[kk]) || rz.isArray(obj[kk])) { processNextKey(obj[kk]) }
        });
      }
      else if (rz.isArray(obj)) {
        obj.forEach((obi, i) => {
          if (rz.isObject(obi)) {
            const keys = rz.objKeys(obi);
            (keys || []).forEach((kk) => {
              if (rz.isString(obi[kk]) && obi[kk].startsWith("%") && obi[kk].endsWith("%")) { obi[kk] = replaceSpecValue(obi[kk]) }
              else if (rz.isObject(obi[kk]) || rz.isArray(obi[kk])) { processNextKey(obi[kk]) }
            });
          }
          else if (rz.isString(obi)) { obj[i] = replaceSpecValue(obi) }
        });
      }
    };
    processNextKey(dbFilter);
    return dbFilter;
  },

  dbFiltersRegexToString: (dbFilter) => {
    if (!dbFilter) { return dbFilter }
    const processNextKey = (obj) => {
      if (rz.isObject(obj)) {
        const keys = rz.objKeys(obj);
        (keys || []).forEach((kk) => {
          // eslint-disable-next-line dot-notation
          if (kk === "$regex" && rz.isRegExp(obj[kk])) { obj[kk] = String(obj[kk]) + (rz.arrContains(keys, "$options") ? obj["$options"] : "") }
          else if (rz.isObject(obj[kk]) || rz.isArray(obj[kk])) { processNextKey(obj[kk]) }
        });
      }
      else if (rz.isArray(obj)) {
        obj.forEach((obi) => {
          if (rz.isObject(obi)) {
            const keys = rz.objKeys(obi);
            (keys || []).forEach((kk) => {
              // eslint-disable-next-line dot-notation
              if (kk === "$regex" && rz.isRegExp(obi[kk])) { obi[kk] = String(obi[kk]) + (rz.arrContains(keys, "$options") ? obi["$options"] : "") }
              else if (rz.isObject(obi[kk]) || rz.isArray(obi[kk])) { processNextKey(obi[kk]) }
            });
          }
        });
      }
    };
    processNextKey(dbFilter);
    return dbFilter;
  },

  dbFiltersRegexFromString: (dbFilter) => {
    if (!dbFilter) { return dbFilter }
    const processNextKey = (obj) => {
      if (rz.isObject(obj)) {
        const keys = rz.objKeys(obj);
        (keys || []).forEach((kk) => {
          if (kk === "$regex" && rz.isString(obj[kk]) && obj[kk].startsWith("/")) { obj[kk] = rz.strToRegExp(obj[kk]) }
          else if (rz.isObject(obj[kk]) || rz.isArray(obj[kk])) { processNextKey(obj[kk]) }
        });
      }
      else if (rz.isArray(obj)) {
        obj.forEach((obi) => {
          if (rz.isObject(obi)) {
            const keys = rz.objKeys(obi);
            (keys || []).forEach((kk) => {
              if (kk === "$regex" && rz.isString(obj[kk]) && obj[kk].startsWith("/")) { obi[kk] = rz.strToRegExp(obj[kk]) }
              else if (rz.isObject(obi[kk]) || rz.isArray(obi[kk])) { processNextKey(obi[kk]) }
            });
          }
        });
      }
    };
    processNextKey(dbFilter);
    return dbFilter;
  },

  objDeleteKeys: (obj, excludeFields, usingSpreadOperator) => { // excludeFields = [".data.entries.waste", "_id", "id"]
    const obj1 = rz.objClone(obj, usingSpreadOperator);
    // @ts-ignore
    if (rz.isArray(excludeFields) && excludeFields.length) {
      // @ts-ignore
      excludeFields.forEach((ff) => {
        if (rz.isString(ff)) {
          const f1 = ff.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
          const f2 = f1.replace(/^\./, ""); // strip a leading dot
          const a = f2.split(".");
          if (a.length === 1) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            try { if (a[0] in obj1) { delete obj1[a[0]] } } catch (err) { /* console.log({_: "objDeleteKeys()", obj: obj1, incomingObject: obj, key: a[0], error: rz.errToString(err)}) */ }
          }
          else {
            let fnd = false, o1 = obj1;
            for (let i = 0; i < a.length; i++) {
              if (a[i] in o1) { o1 = o1[a[i]]; fnd = true } else { break }
              if (i === a.length && fnd) { delete o1[a[i]] }
            }
          }
        }
      });
    }
    return obj1;
  },

  objCloneWithKeys: (obj, includeFields) => {
    const obj1 = {};
    if (rz.isArray(includeFields) && includeFields.length) {
      includeFields.forEach((ff) => {
        if (rz.isString(ff) && (ff in obj)) {
          const f1 = ff.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
          const f2 = f1.replace(/^\./, ""); // strip a leading dot
          const a = f2.split(".");
          if (a.length === 1) {
            obj1[a[0]] = obj[a[0]];
          }
          else {
            let fnd = false, o1 = obj;
            for (let i = 0; i < a.length; i++) {
              if (a[i] in o1) { o1 = o1[a[i]]; fnd = true } else { break }
              if (i === a.length && fnd) { obj1[a[i]] = o1[a[i]] }
            }
          }
        }
      });
    }
    return {...obj1};
  },

  objCompareKeysTypes: (protoObj, checkingObj, excludeFields) => { // excludeFields = [".data.entries.waste", "_id", "id"]
    const errors = [];
    if (!rz.isObject(protoObj)) { errors.push("Argument 'protoObj' is not an Object") }
    if (!rz.isObject(checkingObj)) { errors.push("Argument 'checkingObj' is not an Object") }
    if (excludeFields && !rz.isArray(excludeFields)) { errors.push("Optional argument 'excludeFields' must be an Array. Example: ['.data.entries.waste', '_id', 'id']") }
    if (errors.length) return {result: false, err: errors.join(" \n")};

    // Exclude some fields. if (excludeFields === undefined) it will just clone my objects
    const obj1 = rz.objDeleteKeys(protoObj, excludeFields);
    const obj2 = rz.objDeleteKeys(checkingObj, excludeFields);

    const compare2ObjectsTypes = (o1, o2) => {
      const ent1 = Object.entries(o1), ent2 = Object.entries(o2);
      let ans = true;
      for (let i = 0; i < ent1.length; i++) {
        const e1 = ent1[i], e2 = ent2[i];
        if (e1 && e2) {
          if (e1[0] !== e2[0]) { errors.push("Objects have different Keys: '" + e1[0] + "' & '" + e2[0] + "'"); return false }
          if (typeof e1[1] !== typeof e2[1]) { errors.push("Objects have different Value types in keys: '" + e1[0] + "' & '" + e2[0] + "'"); return false }
          if (rz.isObject(e1[1]) && rz.isObject(e2[1])) { ans &&= compare2ObjectsTypes(e1[1], e2[1]) }
          else {
            ans &&= (
              (rz.isString(e1[1]) && rz.isString(e2[1])) || (rz.isNumber(e1[1]) && rz.isNumber(e2[1])) || (rz.isDate(e1[1]) && rz.isDate(e2[1]))
              || (rz.isFunction(e1[1]) && rz.isFunction(e2[1])) || (rz.isRegExp(e1[1]) && rz.isRegExp(e2[1]))
              || (rz.isArray(e1[1]) && rz.isArray(e2[1])) || (rz.isBoolean(e1[1]) && rz.isBoolean(e2[1]))
              || (rz.isBuffer(e1[1]) && rz.isBuffer(e2[1])) || (rz.isError(e1[1]) && rz.isError(e2[1]))
            );
          }
        }
        else if (e1 && !e2) { errors.push("Key '" + e1[0] + "' is absent in checkingObj"); return false }
        else { errors.push("Unknown error"); return false }
        if (!ans) break;
      }
      return ans;
    }

    const res = compare2ObjectsTypes(obj1, obj2);
    return {result: res && !errors.length, err: errors.join(" \n")};
  },

  /* ================ Numbers ================ */
  numRoundTo: (num, digit) => {
    let x = 0;
    if (rz.isNumber(digit) && rz.numIsInt(digit) && digit >= -6 && digit <= 6) x = digit;
    x = 10 ** x;
    return Math.round(num * x) / x;
  },

  numRoundToNearest: (num, digit) => {
    if (rz.isNumber(digit)) return Number(num % digit ? num + digit - (num % digit) : num);
    return num;
  },

  numToFloatStr: (num, roundTo) => {
    if (!rz.isNumber(num)) { return "" }
    let numb = num; if (typeof roundTo !== "undefined" && roundTo !== null) { numb = rz.numRoundTo(num, roundTo) }
    return new Intl.NumberFormat("ru-RU", {minimumFractionDigits: 0, maximumFractionDigits: 20}).format(numb);
  },

  numRandom: (minIntegerNumber, maxIntegerNumber) => (Math.floor(Math.random() * (maxIntegerNumber - minIntegerNumber + 1)) + minIntegerNumber),

  // Adds zeros in front of the numbers (it is always a fixed length of the number, for example - for protocols numbers)
  prefInt: (number, len) => {
    const zers = Array(len + 1).join("0");
    if (!number || !rz.isNumber(number)) return zers;
    const nms = String(Math.trunc(number));
    const ans = (zers + nms).slice(-len);
    return ans;
  },

  /* =============== Strings =============== */
  strSubString: (fullString, leftString, rightString, startPozSearch) => {
    const s = startPozSearch || 0;
    if (!fullString || s > fullString.length) return "";

    const findPos = (haystack, needle, start) => {
      if (needle instanceof RegExp) {
        // Создаём копию регулярного выражения с флагом 'g', чтобы можно было задать lastIndex
        const flags = needle.flags.includes("g") ? needle.flags : needle.flags + "g";
        const re = new RegExp(needle.source, flags);
        re.lastIndex = start;
        const match = re.exec(haystack);
        return match ? { pos: match.index, length: match[0].length } : null;
      }
      if (typeof needle === "string") {
        const pos = haystack.indexOf(needle, start);
        return pos !== -1 ? { pos, length: needle.length } : null;
      }
      return null;
    };

    // Ищем левую границу
    const leftMatch = leftString ? findPos(fullString, leftString, s) : { pos: s, length: 0 };
    if (!leftMatch) return "";

    // Ищем правую границу
    let rightMatch;
    if (rightString) {
      rightMatch = findPos(fullString, rightString, leftMatch.pos + leftMatch.length);
      if (!rightMatch) {
        // Если правая граница не найдена, можно либо вернуть пустую строку, либо взять до конца строки
        return "";
        // Здесь возьмём до конца строки
        // rightMatch = { pos: fullString.length, length: 0 };
      }
    } else {
      rightMatch = { pos: fullString.length, length: 0 };
    }

    if (leftMatch.pos === -1 || rightMatch.pos === -1) return "";

    return fullString.slice(leftMatch.pos + leftMatch.length, rightMatch.pos);
  },

  strTrimRight: (str) => str.replace(/(\s+|\n+)$/g, ""),

  strTrimLeft: (str) => str.replace(/^(\s+|\n+)/g, ""),

  strReplaceAll: (str, searchArray, replacementArray) => {
    let ans = str, srch = searchArray, rpls = replacementArray;
    if (rz.isString(searchArray)) srch = [String(searchArray)];
    if (rz.isString(replacementArray)) rpls = [String(replacementArray)];
    if (!rz.isString(str) || !rz.isArray(srch) || !rz.isArray(rpls)) return "";
    // @ts-ignore
    srch.forEach((ss, s) => {
      if (rpls.length > s) { ans = ans.split(ss).join(rpls[s]) }
      else { ans = ans.split(ss).join(rpls[rpls.length - 1]) }
    });
    return ans;
  },

  // removes all spaces at the beginning and at the end of the string
  strTrim: (str) => {
    const s = rz.strReplaceAll(str, rz.unknowSpase, " ");
    return rz.strTrimLeft(rz.strTrimRight(s));
  },

  // removes all spaces at the beginning and at the end of the line
  // in addition, it replaces several consecutive gaps within the line by one space
  strTrimMiddle: (str) => {
    const s = rz.strReplaceAll(str, rz.unknowSpase, " ");
    return rz.strTrim(s).replace(/\s\s+/g, " ");
  },

  strTrimAll: (str) => {
    const s = rz.strReplaceAll(str, rz.unknowSpase, "");
    return s.replace(/(\s|\n)/g, "");
  },

  strGetShortFIO: (fullFIO) => {
    let outS = (String(fullFIO || "")).trim();
    if (outS === "") { return "" }
    if (outS.endsWith(".")) { return outS }
    const mPr = rz.strTrimMiddle(outS).split(" ");
    if (mPr.length > 1) {
      outS = mPr[0] + " " + mPr[1].slice(0, 1) + ".";
      if (mPr[2]) outS += mPr[2].slice(0, 1) + ".";
    }
    return outS;
  },

  // Приводит "ФАМИЛИЮ Имя отчество" к "Фамилия Имя Отчетво" - исправляет регистр!
  strFIOcaseAlignment: (name, onlyFirst) => { // normalCase
    if (!name) { return "" }
    if (onlyFirst) { return (name.slice(0, 1).toUpperCase() + name.slice(-name.length + 1)).trim() }
    const words = name.replace((/\./ig), " ").replace((/(\s|\t|\n)+/ig), " ").replace((/ё/ig), "е").trim().split(" ");
    const upd = words.map((ww) => {
      const aa = ww.toLowerCase();
      return aa.slice(0, 1).toUpperCase() + aa.slice(-aa.length + 1);
    });
    return upd.join(" ");
  },

  reverseADuserName: (name) => {
    const str = (name || "").split(" "); return (str.length < 2 || str.length > 2 ? name : str[1] + " " + str[0]);
  },

  strMakeID: (length, onlyHex) => {
    let result = "";
    const characters = (onlyHex ? "ABCDEF0123456789" : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789");
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  },

  strTransliterateRUtoEN: (word) => {
    const a = {
      Ё: "YO",
      Й: "I",
      Ц: "TS",
      У: "U",
      К: "K",
      Е: "E",
      Н: "N",
      Г: "G",
      Ш: "SH",
      Щ: "SCH",
      З: "Z",
      Х: "H",
      Ъ: "'",
      ё: "yo",
      й: "i",
      ц: "ts",
      у: "u",
      к: "k",
      е: "e",
      н: "n",
      г: "g",
      ш: "sh",
      щ: "sch",
      з: "z",
      х: "h",
      ъ: "'",
      Ф: "F",
      Ы: "I",
      В: "V",
      А: "A",
      П: "P",
      Р: "R",
      О: "O",
      Л: "L",
      Д: "D",
      Ж: "ZH",
      Э: "E",
      ф: "f",
      ы: "i",
      в: "v",
      а: "a",
      п: "p",
      р: "r",
      о: "o",
      л: "l",
      д: "d",
      ж: "zh",
      э: "e",
      Я: "Ya",
      Ч: "CH",
      С: "S",
      М: "M",
      И: "I",
      Т: "T",
      Ь: "'",
      Б: "B",
      Ю: "YU",
      я: "ya",
      ч: "ch",
      с: "s",
      м: "m",
      и: "i",
      т: "t",
      ь: "'",
      б: "b",
      ю: "yu"
    };
    return word.split("").map((char) => a[char] || char).join("")
  },

  strFileExtension: (filename) => {
    // Alternate function: path.parse(filename).ext
    const prts = (filename || "").split(".");
    const ext = (prts[prts.length - 1]).trim().toLowerCase();
    return (prts.length > 1 ? ext : "");
  },

  strClearFileName: (filename) => {
    // Alternate function: path.parse(filename).name (or .base - with extention)
    const i = filename.lastIndexOf(".");
    let a = ((i < 0) ? "" : filename.slice(0, i));
    a = rz.strReplaceAll(a, "\\", "/");
    const j = a.lastIndexOf("/");
    const b = ((j < 0) ? a : a.slice(j + 1));
    return b;
  },

  strFileName: (filename) => {
    const a = rz.strReplaceAll(filename, "\\", "/");
    const j = a.lastIndexOf("/");
    const b = ((j < 0) ? a : a.slice(j + 1));
    return b;
  },

  strParentFolderName: (filename) => {
    const a = rz.strReplaceAll(filename, "\\", "/");
    const j = a.lastIndexOf("/");
    const b = ((j < 0) ? "" : a.slice(0, j));
    return b;
  },

  strCreateValidFileName: (filename) => {
    const strFileName = rz.strFileName(String(filename));
    const fileName1 = strFileName.replace(/[^A-Za-z0-9а-яА-Я_-]/gi, "-").trim();
    return fileName1;
  },

  hasUnicode: (str) => {
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127) return true;
    }
    return false;
  },

  strHasRUsymbols: (str) => {
    let hasRu = false;
    if (!str || !rz.isString(str)) return false;
    for (let i = 0; i < str.length; i++) {
      const chCode = str[i].charCodeAt(0);
      if (chCode >= 1040 && chCode <= 1105) {
        hasRu = true; break;
      }
    }
    return hasRu;
  },

  textFromHTML: (html) => (
    (window.$("<div>" + (html || "") + "</div>").text() || "").trim()
  ),

  // @ts-ignore
  numToPhrase: (num, curency) => {
    // let lng = "ru"; if (isString(lngparam)) lng = lngparam;
    const x = rz.numRoundTo(num, 2);
    if (x < 0 || x > 999999999999999) return false;

    let currency = "RUB"; if (rz.isString(curency)) currency = (rz.strTrimAll(String(curency))).toUpperCase();
    if (currency !== "RUB" && currency !== "USD" && currency !== "EUR") return false;

    const groups = [];
    groups[0] = []; groups[1] = []; groups[2] = []; groups[3] = []; groups[4] = []; groups[9] = [];

    // @ts-ignore
    groups[0][-1] = { RUB: "рублей", USD: "долларов США", EUR: "евро" };
    // @ts-ignore
    groups[0][1] = { RUB: "рубль", USD: "доллар США", EUR: "евро" };
    // @ts-ignore
    groups[0][2] = { RUB: "рубля", USD: "доллара США", EUR: "евро" };
    // @ts-ignore
    groups[0][3] = { RUB: "рубля", USD: "доллара США", EUR: "евро" };
    // @ts-ignore
    groups[0][4] = { RUB: "рубля", USD: "доллара США", EUR: "евро" };

    // @ts-ignore
    groups[1][-1] = "тысяч"; groups[1][1] = "тысяча"; groups[1][2] = "тысячи"; groups[1][3] = "тысячи"; groups[1][4] = "тысячи";
    // @ts-ignore
    groups[2][-1] = "миллионов"; groups[2][1] = "миллион"; groups[2][2] = "миллиона"; groups[2][3] = "миллиона"; groups[2][4] = "миллиона";
    // @ts-ignore
    groups[3][-1] = "миллиардов"; groups[3][1] = "миллиард"; groups[3][2] = "миллиарда"; groups[3][3] = "миллиарда"; groups[3][4] = "миллиарда";
    // @ts-ignore
    groups[4][-1] = "триллионов"; groups[4][1] = "триллион"; groups[4][2] = "триллиона"; groups[4][3] = "триллиона"; groups[4][4] = "триллиона";
    // @ts-ignore
    groups[9][-1] = { RUB: "копеек", USD: "центов", EUR: "центов" }; // по умолчанию
    // @ts-ignore
    groups[9][1] = { RUB: "копейка", USD: "цент", EUR: "цент" };
    // @ts-ignore
    groups[9][2] = { RUB: "копейки", USD: "цента", EUR: "цента" };
    // @ts-ignore
    groups[9][3] = { RUB: "копейки", USD: "цента", EUR: "цента" };
    // @ts-ignore
    groups[9][4] = { RUB: "копейки", USD: "цента", EUR: "цента" };

    // цифры и числа либо просто строка, либо 4 строки в хэше
    const names = [];
    names[1] = {0: "один", 1: "одна", 2: "один", 3: "один", 4: "один"};
    names[2] = {0: "два", 1: "две", 2: "два", 3: "два", 4: "два"};
    names[3] = "три"; names[4] = "четыре"; names[5] = "пять"; names[6] = "шесть"; names[7] = "семь"; names[8] = "восемь"; names[9] = "девять"; names[10] = "десять";
    names[11] = "одиннадцать"; names[12] = "двенадцать"; names[13] = "тринадцать"; names[14] = "четырнадцать"; names[15] = "пятнадцать";
    names[16] = "шестнадцать"; names[17] = "семнадцать"; names[18] = "восемнадцать"; names[19] = "девятнадцать"; names[20] = "двадцать";
    names[30] = "тридцать"; names[40] = "сорок"; names[50] = "пятьдесят"; names[60] = "шестьдесят"; names[70] = "семьдесят"; names[80] = "восемьдесят";
    names[90] = "девяносто"; names[100] = "сто"; names[200] = "двести"; names[300] = "триста"; names[400] = "четыреста"; names[500] = "пятьсот";
    names[600] = "шестьсот"; names[700] = "семьсот"; names[800] = "восемьсот"; names[900] = "девятьсот";

    let r = "", i, j, y = Math.floor(x);

    // если НЕ ноль рублей
    if (y > 0) {
      // выделим тройки с руб., тыс., миллионами, миллиардами и триллионами
      const t = [];
      for (i = 0; i <= 4; i++) {
        t[i] = y % 1000;
        y = Math.floor(y / 1000);
      }
      const d = [];
      // выделим в каждой тройке сотни, десятки и единицы
      for (i = 0; i <= 4; i++) {
        d[i] = [];
        // @ts-ignore
        d[i][0] = t[i] % 10; // единицы
        // @ts-ignore
        d[i][10] = (t[i] % 100) - d[i][0]; // десятки
        // @ts-ignore
        d[i][100] = t[i] - d[i][10] - d[i][0]; // сотни
        // @ts-ignore
        d[i][11] = t[i] % 100; // две правых цифры в виде числа
      }

      for (i = 4; i >= 0; i--) {
        if (t[i] > 0) {
          if (names[d[i][100]]) { r += " " + (rz.isObject(names[d[i][100]]) ? names[d[i][100]][i] : names[d[i][100]]) }
          if (names[d[i][11]]) { r += " " + (rz.isObject(names[d[i][11]]) ? names[d[i][11]][i] : names[d[i][11]]) }
          else {
            if (names[d[i][10]]) { r += " " + (rz.isObject(names[d[i][10]]) ? names[d[i][10]][i] : names[d[i][10]]) }
            if (names[d[i][0]]) { r += " " + (rz.isObject(names[d[i][0]]) ? names[d[i][0]][i] : names[d[i][0]]) }
          }

          if (names[d[i][11]]) { j = d[i][11] } // если существует числительное
          else { j = d[i][0] }

          if (groups[i][j]) {
            if (i === 0) { r += " " + groups[i][j][currency] }
            else { r += " " + groups[i][j] }
          }
          else if (i === 0) { r += " " + groups[i][-1][currency] }
          else { r += " " + groups[i][-1] }
        }
      }

      if (t[0] === 0) { r += " " + groups[0][-1][currency] }
    }
    else {
      r = "Ноль " + groups[0][-1][currency];
    }

    y = rz.numRoundTo((x - Math.floor(x)) * 100, 0);
    r = rz.strTrimMiddle(r);
    r = r.slice(0, 1).toUpperCase() + r.slice(1);
    r += " " + (y < 10 ? "0" : "") + y;

    if (names[y]) { j = y }
    else { j = y % 10 }

    if (groups[9][j]) { r += " " + groups[9][j][currency] }
    else { r += " " + groups[9][-1][currency] }

    return r;
  },

  // склонение именительных рядом с числительным: число (typeof = string), корень (не пустой), окончание
  // пример: declOfNum(value, 'копе', ['йка','йки','ек'])
  // еще пример: declOfNum(value, 'книг', ['а','и',''])
  declOfNum: (value, root, ends) => {
    const k = [2, 0, 1, 1, 1, 2, 2, 2, 2, 2];
    const n = (rz.isNumber(value) ? value.toString() : String(value));
    return (root === "" ? "" : " " + root + (n[n.length - 2] === "1" ? ends[2] : ends[k[n[n.length - 1]]]));
  },

  // Работает пока только с целыми числами
  // Пример: numToPhrase2(num) + declOfNum(num, 'книг', ['а','и','']);
  // Выведет: Тридцать три книги
  // feminine = true (женский род) нужно для правильного склонения: не «два книги», а «две книги»
  numToPhrase2: (num, feminine) => {
    // sub-function
    function t(kk, dd) { // преобразовать трёхзначные числа
      const e = [
        ["", " один", " два", " три", " четыре", " пять", " шесть", " семь", " восемь", " девять"],
        [" десять", " одиннадцать", " двенадцать", " тринадцать", " четырнадцать", " пятнадцать", " шестнадцать", " семнадцать", " восемнадцать", " девятнадцать"],
        ["", "", " двадцать", " тридцать", " сорок", " пятьдесят", " шестьдесят", " семьдесят", " восемьдесят", " девяносто"],
        ["", " сто", " двести", " триста", " четыреста", " пятьсот", " шестьсот", " семьсот", " восемьсот", " девятьсот"],
        ["", " одна", " две"]
      ];
      return e[3][kk[0]] + (kk[1] === 1 ? e[1][kk[2]] : e[2][kk[1]] + (dd ? e[4][kk[2]] : e[0][kk[2]]));
    }

    let k = rz.numRoundTo(num, 0).toString();
    let i = "";
    const e = [
      ["", "тысяч", "миллион", "миллиард", "триллион", "квадриллион", "квинтиллион", "секстиллион", "септиллион", "октиллион", "нониллион", "дециллион"],
      ["а", "и", ""],
      ["", "а", "ов"]
    ];

    if (k === "" || k === "0") return "Ноль"; // 0
    // @ts-ignore
    k = k.split(/(?=(?:\d{3})+$)/); // разбить число в массив с трёхзначными числами
    // @ts-ignore
    if (k[0].length === 1) k[0] = "00" + k[0];
    // @ts-ignore
    if (k[0].length === 2) k[0] = "0" + k[0];
    for (let j = (k.length - 1); j >= 0; j--) { // соединить трёхзначные числа в одно число, добавив названия разрядов с окончаниями
      if (k[j] !== "000") {
        i = (((feminine && j === (k.length - 1)) || j === (k.length - 2)) && (k[j][2] === "1" || k[j][2] === "2") ? t(k[j], 1) : t(k[j]))
          + rz.declOfNum(k[j], e[0][k.length - 1 - j], (j === (k.length - 2) ? e[1] : e[2])) + i;
      }
    }

    // Можно было просто так: return i
    // А вот так выведет с заглавной буквы и без лишнего пробела спереди:
    return i[1].toUpperCase() + i.substring(2);
  },

  /* ================ Arrays ================ */
  arrContains: (arr, elem, trimParam, caseNoSensitiveParam) => {
    if (!rz.isArray(arr) || !arr.length || rz.isUndefinedOrNull(elem)) return false;
    const isElemRegExp = rz.isRegExp(elem);
    const isElemString = rz.isString(elem);
    const shouldTrim = (trimParam === true);
    const shouldLowerCase = (caseNoSensitiveParam === true);
    let v = elem;

    if (isElemString) {
      if (shouldTrim) { v = v.trim() }
      if (shouldLowerCase) { v = v.toLowerCase() }
    }

    for (let i = 0; i < arr.length; i++) {
      let a = arr[i];

      if (rz.isString(a)) {
        if (shouldTrim) { a = a.trim() }
        if (shouldLowerCase) { a = a.toLowerCase() }

        if (isElemRegExp) {
          v.lastIndex = 0;
          if (v.test(a)) { return true }
        }
        else if (a === v) {
          return true;
        }
      }
      else if (a && rz.isRegExp(a) && isElemString) {
        a.lastIndex = 0;
        if (a.test(v)) { return true }
      }
      else if (a === v) {
        return true;
      }
    }

    return false;
  },

  arrReplace: (arr, elem, replacement, trimParam, caseNoSensitiveParam, cloneBeforeReplace) => {
    if (!rz.isArray(arr) || !arr.length || rz.isUndefinedOrNull(elem)) return false;
    const targetArr = (cloneBeforeReplace ? rz.objClone(arr) : arr);
    const isElemRegExp = rz.isRegExp(elem);
    const isElemString = rz.isString(elem);
    const shouldTrim = (trimParam === true);
    const shouldLowerCase = (caseNoSensitiveParam === true);
    let v = elem;

    if (isElemString) {
      if (shouldTrim) { v = v.trim() }
      if (shouldLowerCase) { v = v.toLowerCase() }
    }

    for (let i = 0; i < targetArr.length; i++) {
      let a = targetArr[i];

      if (rz.isString(a)) {
        if (shouldTrim) { a = a.trim() }
        if (shouldLowerCase) { a = a.toLowerCase() }

        if (isElemRegExp) {
          v.lastIndex = 0;
          if (v.test(a)) {
            targetArr[i] = replacement;
            break;
          }
        }
        else if (a === v) {
          targetArr[i] = replacement;
        }
      }
      else if (a && rz.isRegExp(a) && isElemString) {
        a.lastIndex = 0;
        if (a.test(v)) {
          targetArr[i] = replacement;
          break;
        }
      }
      else if (a === v) {
        targetArr[i] = replacement;
      }
    }

    return targetArr;
  },

  // Сравнение строк. Поместил тут, т.к. arrContains() определен только что.
  // params = "toUpperCase, toLowerCase, caseNoSensitive, trim, trimMiddle, trimAll, transliterate, substring"
  // или так: strCompare(str1, str2, ".caseNoSensitive.touppercase.tolowercase.trim.trimAll.transliterate.substring")
  strCompare: (str1, str2, params) => {
    if (rz.isUndefinedOrNull(str1) || rz.isUndefinedOrNull(str2)) return false;
    const isstr1 = rz.isString(str1), isstr2 = rz.isString(str2), isregx1 = rz.isRegExp(str1), isregx2 = rz.isRegExp(str2);
    let v1 = str1, v2 = str2, prms = [];
    if (params && rz.isString(params)) {
      prms = rz.strTrimAll(params).toLowerCase().replace(/(,|\.)/g, ";").split(";");
      prms.forEach((p) => {
        if (p === "touppercase" || p === "tolowercase" || p === "casenosensitive") {
          // @ts-ignore
          // eslint-disable-next-line
          if (isstr1) { v1 = v1.toLowerCase() }; if (isstr2) { v2 = v2.toLowerCase() }
        }
        else if (p === "trim") {
          // @ts-ignore
          // eslint-disable-next-line
          if (isstr1) { v1 = rz.strTrim(v1) }; if (isstr2) { v2 = rz.strTrim(v2) }
        }
        else if (p === "trimmiddle") {
          // @ts-ignore
          // eslint-disable-next-line
          if (isstr1) { v1 = rz.strTrimMiddle(v1) }; if (isstr2) { v2 = rz.strTrimMiddle(v2) }
        }
        else if (p === "trimall") {
          // @ts-ignore
          // eslint-disable-next-line
          if (isstr1) { v1 = rz.strTrimAll(v1) }; if (isstr2) { v2 = rz.strTrimAll(v2) }
        }
        else if (p === "transliterate") {
          // @ts-ignore
          // eslint-disable-next-line
          if (isstr1) { v1 = rz.strTransliterateRUtoEN(v1) }; if (isstr2) { v2 = rz.strTransliterateRUtoEN(v2) }
        }
      });
    }

    if (isstr1 && isstr2) {
      // @ts-ignore
      if (rz.arrContains(prms, "substring")) return Boolean(~v1.indexOf(v2));
      return Boolean(v1 === v2);
    }
    // @ts-ignore
    if (isstr1 && isregx2) { v2.lastIndex = 0; return v2.test(v1) }
    // @ts-ignore
    if (isstr2 && isregx1) { v1.lastIndex = 0; return v1.test(v2) }
    return false;
  },

  strReverse: (str1) => (str1.split("").reverse().join("")),

  strFromSelectedLng: ({lng, def, ru, en, tr}) => {
    if (!lng || !~["ru", "en", "tr"].indexOf(lng)) { return def || "" }
    if (lng === "ru" && ru) { return ru }
    if (lng === "en" && en) { return en }
    if (lng === "tr" && tr) { return tr }
    if (def) {
      if (lng === "ru" && rz.strHasRUsymbols(def)) { return def }
      if (lng === "en" && !rz.strHasRUsymbols(def)) { return def }
    }
    return en || ru || tr || def || "";
  },

  // ============== ARRAYS ==============

  // Check 2 arrays are similar or not
  // compareMethod = "exact" | "includesAll" | "includesAny" | "getDifferenceArr"
  // @ts-ignore
  arrCompare: (arr1, arr2, compareMethod, trimParam, caseNoSensitiveParam) => {
    if (!rz.isArray(arr1)) return false;
    let ar1 = rz.objClone(arr1); if (!rz.isArray(arr1)) ar1 = [arr1];
    let ar2 = rz.objClone(arr2); if (!rz.isArray(arr2)) ar2 = [arr2];
    if (trimParam) {
      ar1 = ar1.map((a) => (rz.isString(a) ? a.trim() : a));
      ar2 = ar2.map((a) => (rz.isString(a) ? a.trim() : a));
    }
    if (caseNoSensitiveParam && compareMethod !== "getDifferenceArr") {
      ar1 = ar1.map((a) => (rz.isString(a) ? a.toLowerCase() : a));
      ar2 = ar2.map((a) => (rz.isString(a) ? a.toLowerCase() : a));
    }
    let ans, fnd;
    if (compareMethod === "exact") {
      if (ar1.length !== ar2.length) return false;
      ar1.sort((a, b) => (a < b ? -1 : (a > b ? 1 : 0)));
      ar2.sort((a, b) => (a < b ? -1 : (a > b ? 1 : 0)));
      ans = true;
      for (let i = 0; i < ar1.length; i++) {
        if (ar1[i] !== ar2[i]) { ans = false; break }
      }
    }
    else if (compareMethod === "includesAll") {
      ans = true;
      for (let i = 0; i < ar2.length; i++) {
        fnd = false;
        for (let j = 0; j < ar1.length; j++) {
          if (ar2[i] === ar1[j]) { fnd = true; break }
        }
        if (!fnd) { ans = false; break }
      }
    }
    else if (compareMethod === "includesAny") {
      ans = false;
      for (let i = 0; i < ar2.length; i++) {
        for (let j = 0; j < ar1.length; j++) {
          if (ar2[i] === ar1[j]) { ans = true; break }
        }
        if (ans) break;
      }
    }
    else if (compareMethod === "getDifferenceArr") {
      const newArr = [];
      for (let i = 0; i < ar2.length; i++) {
        fnd = false;
        for (let j = 0; j < ar1.length; j++) {
          if (caseNoSensitiveParam && rz.isString(ar2[i]) && rz.isString(ar1[j]) && ar2[i].toLowerCase() === ar1[j].toLowerCase()) { fnd = true; break }
          else if (ar2[i] === ar1[j]) { fnd = true; break }
        }
        if (!fnd) { newArr.push(ar2[i]) }
      }
      return newArr;
    }
    return ans;
  },

  // Find i-Object in Array using Some fields. arrFindObj (arr, obj, comparedFields: ["name", "internalip"...])
  arrFindObj: (arr, obj, comparedFields) => {
    if (!rz.isArray(arr) || !rz.isObject(obj)) return -1;
    let ans = -1, str2 = "";
    if (comparedFields && rz.isArray(comparedFields)) {
      for (let i = 0; i < arr.length; i++) {
        let brk = false;
        for (let j = 0; j < comparedFields.length; j++) {
          if (arr[i][comparedFields[j]] !== obj[comparedFields[j]]) {
            brk = true; break;
          }
        }
        if (!brk) {
          ans = i; break;
        }
      }
    }
    else {
      str2 = JSON.stringify(obj);
      for (let i = 0; i < arr.length; i++) {
        const oo = arr[i], obj1 = {}; let str1 = "";
        const flds = rz.objKeys(obj);
        for (let j = 0; j < flds.length; j++) {
          if (rz.objHasKey(oo, flds[j])) obj1[flds[j]] = oo[flds[j]];
        }
        str1 = JSON.stringify(obj1);
        if (str1 === str2) { ans = i; break }
      }
    }
    return ans; // (-1 || 0...arr.length)
  },

  arrPush: (mainMtrx, addedMtrx, cloneBeforePush) => {
    // mainMtrx и addedMtrx могут быть матрицей, а могут и не быть ей (просто строка или число)
    const mm = (cloneBeforePush ? rz.objClone(mainMtrx) : mainMtrx);
    const am = (cloneBeforePush ? rz.objClone(addedMtrx) : addedMtrx);

    const result = (rz.isArray(mm) ? mm : [mm]);
    if (rz.isArray(am)) { result.push(...am) }
    else { result.push(am) }

    return result;
  },

  arrRemove: (mainMtrx, deletedMtrx, delNullValuesParam, trimParam, caseNoSensitiveParam) => {
    const result = [];
    const smplMtrx = (rz.isArray(mainMtrx) ? mainMtrx : [mainMtrx]);
    const delMtrx = (rz.isArray(deletedMtrx) ? deletedMtrx : [deletedMtrx]);

    const normalizeValue = (value) => {
      if (!rz.isString(value)) { return value }
      let normalized = value;
      if (trimParam) { normalized = normalized.trim() }
      if (caseNoSensitiveParam) { normalized = normalized.toLowerCase() }
      return normalized;
    };

    const deletedSet = new Set(delMtrx.map((value) => (normalizeValue(value))));

    for (let i = 0; i < smplMtrx.length; i++) {
      const sourceValue = smplMtrx[i];
      const normalizedValue = normalizeValue(sourceValue);
      const canBeKept = (!delNullValuesParam || (rz.isString(normalizedValue) && normalizedValue !== ""));
      if (canBeKept && !deletedSet.has(normalizedValue)) {
        result.push(sourceValue);
      }
    }

    return result;
  },

  arrGetUnique: (mainMtrx, delNullValuesParam, trimParam, caseNoSensitiveParam) => {
    if (!rz.isArray(mainMtrx) || !mainMtrx.length) { return [] }

    const result = [];
    const seen = new Set();

    const normalizeValue = (value) => {
      if (!rz.isString(value)) { return value }
      let normalized = value;
      if (trimParam) { normalized = normalized.trim() }
      if (caseNoSensitiveParam) { normalized = normalized.toLowerCase() }
      return normalized;
    };

    for (let i = 0; i < mainMtrx.length; i++) {
      const sourceValue = mainMtrx[i];
      const normalizedValue = normalizeValue(sourceValue);

      if (!(delNullValuesParam && normalizedValue === "") && !seen.has(normalizedValue)) {
        seen.add(normalizedValue);
        result.push(sourceValue);
      }
    }

    return result;
  },

  /* ================== String to Numbers ================== */
  strToNum: (str, roundparam, absparam) => {
    if (rz.isNumber(str)) {
      let ans1 = Number(str);
      if (absparam) ans1 = Math.abs(ans1);
      if (roundparam) ans1 = rz.numRoundTo(ans1, roundparam);
      return ans1;
    }
    if (!str || !rz.isString(str)) return 0;
    const rg = /^-?(\d+(\.\d*)?|\.\d+)$/;
    // \-? - может в начале стоит минус, а может и нет
    // \d+(\.\d+)? - [цифра или несколько] точка и несколько цифр после нее (а может и нет точки и цифр после нее)
    // \.\d+ - число вроде .575 (начинается с точки)
    const sNum = rz.strReplaceAll(str.replace(/\s+/g, "").replace(/,/, "."), rz.unknowSpase, "");
    const allNums = sNum.match(rg); // Сердце функции
    if (!allNums || !allNums.length) return 0;
    try {
      let ans = Number(allNums[0]);
      if (absparam) ans = Math.abs(ans);
      if (roundparam) ans = rz.numRoundTo(ans, roundparam);
      return ans;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    catch (e) {
      return 0;
    }
  },

  // Возвращает массив из всех чисел в строке. Числа могут быть целыми, отрицательными, дробными...
  strGetAllNumbers: (str, roundparam, absparam) => {
    if (!rz.isString(str)) return [];
    const sNum = rz.strReplaceAll(rz.strReplaceAll(str, ",", "."), rz.unknowSpase, "");
    const rg = /-?\d+(\.\d+)?/gi;
    // \-? - может в начале стоит минус, а может и нет
    // \d+(\.\d+)? - [цифра или несколько] точка и несколько цифр после нее (а может и нет точки и цифр после нее)
    // \.\d+ - число вроде .575 (начинается с точки) - этот вариант я убрал

    const allNums = sNum.match(rg);

    if (allNums && rz.isArray(allNums) && allNums.length) {
      const newArr = [];
      for (let i = 0; i < allNums.length; i++) {
        newArr.push(rz.strToNum(allNums[i]));
        if (absparam) newArr[i] = Math.abs(newArr[i]);
        if (roundparam) newArr[i] = rz.numRoundTo(newArr[i], roundparam);
      }
      return newArr;
    }
    return [];
  },

  // Возвращает i-число из строки (может быть отрицательным или дробным)
  strSearchNum: (str, indexNum, roundparam, absparam) => {
    if (!rz.isRealValue(str)) return 0;
    let retVal = 0;
    const allNumbers = rz.strGetAllNumbers(str, roundparam, absparam);
    if (rz.isArray(allNumbers)) {
      if (indexNum === 0) { retVal = allNumbers[allNumbers.length - 1] }
      else if (rz.numIsInt(indexNum) && rz.isNumber(allNumbers[indexNum - 1])) { retVal = allNumbers[indexNum - 1] }
    }
    return retVal;
  },

  strToRegExp: (str, replaceDoubleSlash) => {
    if (!rz.isString(str) || !rz.canBeRegexp(str)) { return undefined } // (/^\/.*\/[gimsuy]*$/).test(str.trim())
    const spl = str.trim().split("/"); let sls = str.slice(1, -((spl[spl.length - 1]).length + 1));
    if (replaceDoubleSlash) { sls = rz.strReplaceAll(sls, ["\\\\"], ["\\"]) }
    let rg; try { rg = new RegExp(sls, spl[spl.length - 1] || "") } catch (err) { console.log(err) }
    return rg;
  },

  /* ================= Dates / Даты ================= */
  dateGetWeekDay: (date, lngparam) => {
    let lng = "ru"; if (rz.isString(lngparam)) lng = String(lngparam);
    let days;
    if (lng === "ru") {
      days = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"];
    } else {
      days = ["su", "mo", "tu", "we", "th", "fr", "sa"];
    }
    return days[date.getDay()];
  },

  detectStrDateFormat: (strDate, forDateJSlib) => {
    let frmt = "";
    if (!strDate || !rz.isString(strDate)) { return frmt }
    if ((/^(\d{4}-\d{2}-\d{2})$/igm).test(strDate)) { frmt = "YYYY-MM-DD" }
    else if ((/^(\d{4}-\d{2}-\d{2}\s\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD hh:mm") }
    else if ((/^(\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD hh:mm:ss") }
    else if ((/^(\D{2}\s\d{4}-\d{2}-\d{2})$/igm).test(strDate)) { frmt = "dd YYYY-MM-DD" }
    else if ((/^(\D{2}\s\d{4}-\d{2}-\d{2}\s\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "dd YYYY-MM-DD HH:mm" : "dd YYYY-MM-DD hh:mm") }
    else if ((/^(\D{2}\s\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "dd YYYY-MM-DD HH:mm:ss" : "dd YYYY-MM-DD hh:mm:ss") }
    else if ((/^(\d{2}\.\d{2}\.\d{4})$/igm).test(strDate)) { frmt = "DD.MM.YYYY" }
    else if ((/^(\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY hh:mm") }
    else if ((/^(\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "DD.MM.YYYY HH:mm:ss" : "DD.MM.YYYY hh:mm:ss") }
    else if ((/^(\D{2}\s\d{2}\.\d{2}\.\d{4})$/igm).test(strDate)) { frmt = "dd DD.MM.YYYY" }
    else if ((/^(\D{2}\s\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "dd DD.MM.YYYY HH:mm" : "dd YYYY-MM-DD hh:mm") }
    else if ((/^(\D{2}\s\d{2}\.\d{2}\.\d{4}\s\d{2}:\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "dd DD.MM.YYYY HH:mm:ss" : "dd YYYY-MM-DD hh:mm:ss") }
    else if ((/^(\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "HH:mm" : "hh:mm") }
    else if ((/^(\d{2}:\d{2}:\d{2})$/igm).test(strDate)) { frmt = (forDateJSlib ? "HH:mm:ss" : "hh:mm:ss") }
    return frmt;
  },

  dateGetMonthName: (month, getGenitiveName) => {
    const mth = (rz.isString(month) ? Number(month) - 1 : month); // Exclamation: if month is number - the first month = 0 and the last month = 11 (not 12)
    const mns = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"];
    const mnr = ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"];
    // @ts-ignore
    if (mth > -1 && mth < 12) return (getGenitiveName ? mnr[mth] : mns[mth]);
    return "";
  },

  dateToString: (date, formatparam, lngparam, hoursOffset) => {
    // Выводит в формате "YYYY-MM-DD"
    if (!rz.isDate(date)) return "";
    let frmt = "YYYY-MM-DD"; if (formatparam && rz.isString(formatparam)) frmt = formatparam;
    const ssDate = rz.objClone(date);
    if (hoursOffset) ssDate.setTime(ssDate.getTime() + (hoursOffset * 60000 * 60));

    const realMonth = +ssDate.getMonth() + 1;
    const realDate = +ssDate.getDate();
    const ye = ssDate.getFullYear();
    const mnth = (realMonth < 10 ? "0" : "") + realMonth;
    const da = (realDate < 10 ? "0" : "") + realDate;
    let h = "0" + ssDate.getHours(); h = h.slice(-2);
    let m = "0" + ssDate.getMinutes(); m = m.slice(-2);
    let s = "0" + ssDate.getSeconds(); s = s.slice(-2);

    let strDate = "";
    switch (frmt) {
      case "DD.MM.YYYY":
        strDate = da + "." + mnth + "." + ye;
        break; // DD.MM.YYYY
      case "DD.MM.YYYY hh:mm":
        strDate = da + "." + mnth + "." + ye + " " + h + ":" + m;
        break; // DD.MM.YYYY hh:mm
      case "DD.MM.YYYY hh:mm:ss":
        strDate = da + "." + mnth + "." + ye + " " + h + ":" + m + ":" + s;
        break; // DD.MM.YYYY hh:mm
      case "YYYY-MM-DD hh:mm:ss":
        strDate = ye + "-" + mnth + "-" + da + " " + h + ":" + m + ":" + s;
        break; // YYYY-MM-DD hh:mm:ss
      case "YYYY-MM-DD hh:mm":
        strDate = ye + "-" + mnth + "-" + da + " " + h + ":" + m;
        break; // YYYY-MM-DD hh:mm
      case "dd YYYY-MM-DD hh:mm:ss":
        strDate = rz.dateGetWeekDay(ssDate, lngparam) + " " + ye + "-" + mnth + "-" + da + " " + h + ":" + m + ":" + s;
        break; // пн YYYY-MM-DD hh:mm:ss
      case "dd YYYY-MM-DD hh:mm":
        strDate = rz.dateGetWeekDay(ssDate, lngparam) + " " + ye + "-" + mnth + "-" + da + " " + h + ":" + m;
        break; // пн YYYY-MM-DD hh:mm
      case "dd DD.MM.YYYY":
        strDate = rz.dateGetWeekDay(ssDate, lngparam) + " " + da + "." + mnth + "." + ye;
        break; // пн DD.MM.YYYY
      case "dd DD.MM.YYYY hh:mm":
        strDate = rz.dateGetWeekDay(ssDate, lngparam) + " " + da + "." + mnth + "." + ye + " " + h + ":" + m;
        break; // пн DD.MM.YYYY hh:mm
      case "dd DD.MM.YYYY hh:mm:ss":
        strDate = rz.dateGetWeekDay(ssDate, lngparam) + " " + da + "." + mnth + "." + ye + " " + h + ":" + m + ":" + s;
        break; // пн DD.MM.YYYY hh:mm:ss
      case "hh:mm:ss":
        strDate = h + ":" + m + ":" + s;
        break; // hh:mm:ss
      case "hh:mm":
        strDate = h + ":" + m;
        break; // hh:mm:ss
      case "« DD » MMMM YYYY г.":
        strDate = "« " + da + " » " + rz.dateGetMonthName(mnth, true) + " " + ye + " г.";
        break;
      default:
        strDate = ye + "-" + mnth + "-" + da;
        break; // YYYY-MM-DD
    }
    return strDate;
  },

  // @ts-ignore
  dateFromString: (dateStr, formatparam, hoursOffset) => {
    if (!rz.isString(dateStr)) return null;
    let frmt;
    if (!formatparam) { frmt = rz.detectStrDateFormat(dateStr) }
    else if (formatparam && rz.isString(formatparam)) frmt = formatparam;
    else { return null }
    let da, mnth, ye, dStr, hh = 0, mm = 0, ss = 0;
    switch (frmt) {
      case "DD.MM.YYYY":
        dStr = dateStr.split(".");
        da = +dStr[0];
        mnth = +dStr[1] - 1;
        ye = +dStr[2];
        break; // DD.MM.YYYY
      case "DD.MM.YYYY hh:mm":
      case "DD.MM.YYYY hh:mm:ss": {
        const dts1 = rz.strSubString(dateStr, "", " ");
        if (dts1 === "") {
          dStr = dateStr.split(".");
          da = +dStr[0];
          mnth = +dStr[1] - 1;
          ye = +dStr[2];
          break; // DD.MM.YYYY
        }
        else {
          const dts2 = rz.strSubString(dateStr, " ", "");
          dStr = dts1.split(".");
          da = +dStr[0];
          mnth = +dStr[1] - 1;
          ye = +dStr[2]; // DD.MM.YYYY
          const dTime = dts2.split(":");
          hh = +dTime[0]; // hh:mm:ss
          if (dTime.length > 1) mm = +dTime[1];
          if (dTime.length > 2) ss = +dTime[2];
        }
        break;
      }
      case "YYYY-MM-DD hh:mm:ss": {
        const dts1 = rz.strSubString(dateStr, "", " ");
        if (dts1 === "") {
          dStr = dateStr.split("-");
          da = +dStr[2];
          mnth = +dStr[1] - 1;
          ye = +dStr[0];
          break; // YYYY-MM-DD
        }
        else {
          const dts2 = rz.strSubString(dateStr, " ", "");
          dStr = dts1.split("-");
          da = +dStr[2];
          mnth = +dStr[1] - 1;
          ye = +dStr[0]; // YYYY-MM-DD
          const dTime = dts2.split(":");
          hh = +dTime[0]; // hh:mm:ss
          if (dTime.length > 1) mm = +dTime[1];
          if (dTime.length > 2) ss = +dTime[2];
        }
        break;
      }
      default:
        dStr = dateStr.split("-");
        da = +dStr[2];
        mnth = +dStr[1] - 1;
        ye = +dStr[0];
        break; // YYYY-MM-DD
    }

    let data;
    try {
      data = new Date(ye, mnth, da, hh, mm, ss);
      if (hoursOffset) data.setTime(data.getTime() + (hoursOffset * 60000 * 60));
    } catch (ex) {
      console.log(ex);
    }
    return data || 0;
  },

  dateDaysBetween: (d1, d2, ignoreAbs) => {
    if (!rz.isDate(d1)) return 0;
    let dd2 = rz.objClone(d2); if (!d2 || !rz.isDate(d2)) dd2 = new Date(); // Now()
    try {
      let timeDiff = (d1.getTime() - dd2.getTime());
      if (ignoreAbs !== false) timeDiff = Math.abs(timeDiff);
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) - 1;
      return diffDays;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    catch (e) {
      return 0;
    }
  },

  dateTimeDiff: (date1, date2, ansFormat, ignoreAbs) => { // ansFormat = "miliseconds" | "seconds" | "minutes" | "hours" | "days"
    if (!rz.isDate(date1)) return 0;
    let dd2 = rz.objClone(date2); if (!date2 || !rz.isDate(date2)) dd2 = new Date(); // Now()
    let timeDiff = date1.getTime() - dd2.getTime();
    if (ignoreAbs !== true) timeDiff = Math.abs(timeDiff);
    switch (ansFormat) {
      case "seconds": return Math.ceil(timeDiff / 1000);
      case "minutes": return Math.ceil(timeDiff / 1000 / 60);
      case "hours": return Math.ceil(timeDiff / 1000 / 60 / 60);
      case "days": return Math.ceil(timeDiff / 1000 / 60 / 60 / 24);
      case "miliseconds":
      default: return Math.ceil(timeDiff);
    }
  },

  dateFromISO: (dateStr) => (new Date(dateStr)),

  dateToISO: (date1, toISO8601) => {
    if (!rz.isDate(date1)) return "";
    const preString = date1.toISOString();
    if (toISO8601) { return preString } // 2011-12-19T15:28:46.493Z
    const timeShift = rz.dateTimezoneOffset();
    const resultString = rz.strSubString(preString, "", ".") + (timeShift >= 0 ? "+" : "") + rz.prefInt(timeShift, 2) + ":00";
    return resultString; // 2024-10-18T09:09:02+03:00
  },

  dateDetectTimeShift: (date) => {
    let ds1 = rz.objClone(date), timeshift = 0;
    // @ts-ignore
    if (rz.isDate(date)) ds1 = rz.dateToString(date, "YYYY-MM-DD hh:mm:ss");
    if (!ds1.endsWith("00:00:00") && ds1.endsWith(":00:00")) timeshift = -Number(rz.strSubString(ds1, " ", ":00:00"));
    return timeshift;
  },

  dateTimezoneOffset: (d1) => {
    let ds1; if (!d1 || !rz.isDate(d1)) { ds1 = new Date() } else { ds1 = d1 }
    return -(ds1.getTimezoneOffset() / 60);
  },

  validateTimestamp: (timestamp) => {
    if (!/\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/.test(timestamp)) return false;
    const split = timestamp.split(/[^\d]+/);
    // const year = parseFloat(split[0]);
    const month = parseFloat(split[1]);
    const day = parseFloat(split[2]);
    const hour = parseFloat(split[3]);
    const minute = parseFloat(split[4]);
    const second = parseFloat(split[5]);
    return hour < 25 && minute < 61 && second < 61 && month < 13 && day < 32;
  },

  ExcelDateToJSDate: (serial) => {
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    const fractional_day = serial - Math.floor(serial) + 0.0000001;
    let total_seconds = Math.floor(86400 * fractional_day);
    const seconds = total_seconds % 60;
    total_seconds -= seconds;
    const hours = Math.floor(total_seconds / (60 * 60));
    const minutes = Math.floor(total_seconds / 60) % 60;
    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
  },

  JSDateToExcelDate: (date, timeHoursDiff) => {
    const td = rz.objClone(date);
    if (!rz.isDate(td)) return 0;
    td.setTime(td.getTime() + (timeHoursDiff ? (timeHoursDiff * 60000 * 60) : (6 * 60000 * 60))); // Default: td.addHours(6);
    return (Number(td) / 86400000) + 25569;
  },

  // 108000000 -> "00:30" - convert milliseconds time to string "hours:minutes" (:second - optional)
  timeMillisecondsToTimeStr: (milliseconds, formatparam) => {
    const frmt = formatparam || "hh:mm";
    if (!milliseconds || !rz.isNumber(milliseconds)) return "00:00" + (frmt === "hh:mm:ss" ? ":00" : "");
    let msec = milliseconds || 0;
    const hrs = Math.floor(milliseconds / 1000 / 60 / 60);
    msec -= hrs * 1000 * 60 * 60;
    const min = Math.floor(msec / 1000 / 60);
    msec -= min * 1000 * 60;
    const sec = Math.floor(msec / 1000);
    msec -= sec * 1000;
    const ans = rz.prefInt(hrs, 2) + ":" + rz.prefInt(min, 2) + (frmt === "hh:mm:ss" ? ":" + rz.prefInt(sec, 2) : "");
    return ans;
  },

  // "00:30" -> 108000000 milliseconds
  timeParseFromStr: (strTime, formatparam) => {
    if (!strTime || !rz.isString(strTime) || !(/^\d\d:\d\d(:\d\d)?$/i).test(strTime)) return 0;
    const tm = strTime.split(":").map((ss) => Number(ss)); // strGetAllNumbers(strTime, 0, true);
    if (!tm || tm.length < 2) return 0;
    let ans = tm[0] * 1000 * 60 * 60;
    ans += tm[1] * 1000 * 60;
    if (formatparam !== "hh:mm" && tm.length === 3) ans += tm[1] * 1000;
    return ans;
  },

  /* ================ Encoding - Decoding ================ */
  Base64encode: (str, charCode) => {
    let ans = "";
    if (rz.isClientSide) {
      try { ans = btoa(str) } catch (err) { console.log(err) }
    }
    else {
      try { const buff = Buffer.from(str, charCode || "utf8"); ans = buff.toString("base64") } catch (err) { console.log(err) }
    }
    return ans;
  },

  Base64decode: (str, charCode) => {
    let ans = "";
    if (rz.isClientSide) {
      try { ans = atob(str) } catch (err) { console.log(err) }
    }
    else {
      try { const buff = Buffer.from(str, charCode || "base64"); ans = buff.toString(charCode || "utf8") } catch (err) { console.log(err) }
    }
    return ans;
    // ascii , utf8 , ucs2 , base64 , binary
  },

  base64toBlob: (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = rz.Base64decode(b64Data, "base64");
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  },

  blobToBase64: (blob) => new Promise((resolve, reject) => {
    if (rz.isClientSide) {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        // @ts-ignore
        resolve(reader.result);
      };
      reader.readAsDataURL(blob);
    }
    else {
      reject(new Error("rz.blobToBase64 works only for Client-Side yet"));
    }
  }),

  toArrayBuffer: (buffer) => (Uint8Array.from(buffer).buffer),

  toBuffer: (arrayBuffer) => (Buffer.from(arrayBuffer)),

  symbolFromASCcode: (oneSymbolCode) => (String.fromCharCode(oneSymbolCode)),

  /* Universal functions */
  pathParentModule: () => {
    let ans = "???";
    // @ts-ignore
    if (module && module.parent) { // Server-code
      // @ts-ignore
      const mpath = rz.strReplaceAll(module.parent.filename, "\\", "/").split("/");
      ans = mpath[mpath.length - 1];
      if (mpath.length > 1) ans = mpath[mpath.length - 2] + "/" + mpath[mpath.length - 1];
    }
    else { // Client-code
      const errstack = String((new Error()).stack).replace("Error\n", "").split("\n"), stk = [];
      errstack.forEach((ee) => { stk.push(ee.trim().replace(/^at\s/g, "")) });
      // Analise Err.stack
      for (let i = 0; i < stk.length; i++) {
        if ((/\[as log\]/g).test(stk[i])) {
          ans = stk[i + 1] || stk[i];
          break;
        }
      }
      const regex1 = /\/js\/([a-z]+\.(js|jsx|ejs))/ig;
      // @ts-ignore
      if (regex1.test(ans)) ans = ans.match(regex1)[0];
    }
    return ans;
  },

  errToString: (errarg) => {
    if (!errarg) return "";
    if (rz.isError(errarg)) return errarg.toString();
    if (rz.isObject(errarg)) {
      // @ts-ignore
      if (errarg.err) { return errarg.err }
      let jsn; try { jsn = JSON.stringify(errarg) } catch (err) { console.log(err) }
      return jsn || String(errarg);
    }
    if (rz.isString(errarg)) {
      // @ts-ignore
      if (errarg.startsWith("{") && errarg.endsWith("}")) {
        // @ts-ignore
        const jsns = (rz.strReplaceAll(errarg, "'", "\"")).trim(); let jsn; try { jsn = JSON.parse(jsns) } catch (err) { console.log(err) }
        if (jsn && jsn.err) { return jsn.err }
      }
      return errarg;
    }
    return String(errarg);
  },

  // console.log() | toServerConsole()
  log: async (prms) => {
    // prms = {message, level, module, caller, userip, toserver};
    // prms can be a simple String

    let message = "", level = "info", module, userip = "", caller = "";
    if (!prms || (!rz.isString(prms) && !rz.isObject(prms))) { return }
    // @ts-ignore
    if (rz.isString(prms)) { message = prms; module = rz.pathParentModule() }
    else {
      message = prms.message || prms.msg || prms.error || prms.err;
      if (rz.isError(message)) { message = rz.errToString(message) }
      else if (rz.isObject(message)) { message = JSON.stringify(message) }
      level = (prms.level || prms.msgtype || "info").replace("warning", "warn");
      caller = prms.caller || ""; module = prms.module || rz.pathParentModule(); userip = prms.userip || "";
    }

    // eslint-disable-next-line max-len
    message = rz.dateToString(new Date(), "YYYY-MM-DD hh:mm:ss") + ": " + message + "                { clientSide: true, level: " + level + ", module: " + module + (caller ? ", caller: " + caller : "") + (prms.toserver ? ", toserver: " + prms.toserver : "") + (userip ? ", userip: " + userip : "") + " } ";

    if (prms.toserver && rz.isClientSide) {
      const res = await fetch("/api/toserverlog", {method: "POST", body: JSON.stringify({...prms, message: "ClientSide: " + message}), headers: {"Content-Type": "application/json;charset=utf-8", Accept: "application/json"}});
      const ans1 = await res.json();
      if (ans1.userip) { message = message.replace((/,\suserip:\s\d{1,3}\.d{1,3}\.d{1,3}\.d{1,3}/igm), ", userip: " + ans1.userip) }
      // ***********************************
      console.log(message);
      // ***********************************
    }
    else {
      // ***********************************
      console.log(message);
      // ***********************************
    }
  },

  // Only for Client-side
  syslogserver: (message) => new Promise((resolve) => {
    const app = (window && window.$ && window.$("html").attr("data-app")) || "srvbg-app";
    fetch("/api/syslogserver", {method: "POST", body: JSON.stringify({message, app}), headers: {"Content-Type": "application/json;charset=utf-8"}}).then((res) => res.json().then((ans) => {
      resolve(ans);
    })).catch((err) => { resolve({result: false, err: rz.errToString(err)}) });
  }),

  // fetch helpers
  fetchGetHeaders: (response, header) => {
    const ans = { result: false, headers: [], values: [], header, value: undefined };
    if (response && response.headers) {
      // eslint-disable-next-line no-restricted-syntax
      for (const pair of response.headers.entries()) {
        if (pair.length) {
          // @ts-ignore
          ans.headers.push(pair[0]); ans.values.push(pair[1]);
          if (header && header !== "") {
            if (pair[0].toLowerCase() === header.toLowerCase()) { ans.header = pair[0]; ans.value = pair[1]; ans.result = true }
          }
          else {
            ans.result = true;
          }
        }
      }
    }
    return ans;
  },

  // async-await helpers
  delay: (ms) => new Promise((resolve) => {
    setTimeout(resolve, ms);
  }),

  // compareIP (ip, mask) => true / false. "mask" can be String || Regexp || Array(String || Regexp)
  compareIP: (ip, mask) => {
    let ans = false; if (!ip || !rz.isString(ip) || !mask) return ans;
    if (rz.isString(mask)) { return Boolean(ip === mask) }
    // @ts-ignore
    if (rz.isRegExp(mask)) { mask.lastIndex = 0; return (mask.test(ip)) }
    if (rz.isArray(mask)) {
      // @ts-ignore
      for (let i = 0; i < mask.length; i++) {
        if (rz.isString(mask[i]) && ip === mask[i]) { ans = true; break }
        if (rz.isRegExp(mask[i])) { mask[i].lastIndex = 0; if (mask[i].test(ip)) { ans = true; break } }
      }
    }
    return ans;
  },

  switchCase: (arr) => {
    if (!rz.isArray(arr) || arr.length < 2) { return false }
    for (let i = 0; i < arr.length; i += 2) {
      if (arr[i] && (i + 1) <= (arr.length - 1)) { return arr[i + 1] }
    }
    if ((arr.length % 2) > 0) { return arr[arr.length - 1] }
    return false;
  },

  urlPathname: () => {
    // @ts-ignore
    if (module && module.parent) return ""; // Server-code
    // Client-side:
    return window.location.pathname;
  },

  urlQueryString: () => {
    // @ts-ignore
    if (module && module.parent) return ""; // Server-code
    // Client-side:
    return window.location.search; // rz.strSubString(window.location.href, "?", "");
  },

  urlQueryObject: () => {
    // @ts-ignore
    if (module && module.parent) return {}; // Server-code
    // Client-side:
    const qs = window.location.search; // rz.strSubString(window.location.href, "?", "");
    if (!qs || !~qs.indexOf("=")) return {};
    // @ts-ignore
    return new Proxy(new URLSearchParams(qs), { get: (searchParams, prop) => (searchParams.get(prop)) });
  },

  parseCSSText: (cssText) => {
    const cssTxt = cssText.replace(/\/\*(.|\s)*?\*\//g, " ").replace(/\s+/g, " ");
    const style = {};
    const rule = (cssTxt.match(/ ?(.*?) ?{([^}]*)}/) || [])[2] || cssTxt;
    const cssToJs = (s) => (s.replace(/\W+\w/g, (match) => match.slice(-1).toUpperCase()));
    const properties = rule.split(";").map((o) => (o.split(":").map((x) => x && x.trim())));
    // eslint-disable-next-line no-restricted-syntax
    for (const [property, value] of properties) { style[cssToJs(property)] = value }
    return style;
  },

  cssObjectToString: (cssObject) => {
    if (!cssObject || !rz.isObject(cssObject)) { return "" }
    const cssString = Object.entries(cssObject).map(([prop, value]) => {
      // Convert camelCase to kebab-case
      const cssProp = prop.replace(/[A-Z]/g, (match) => (`-${match.toLowerCase()}`));
      return `${cssProp}:${value};`;
    }).join("");
    return cssString;
  },

  getCryptoKey: async (req) => {
    // @ts-ignore
    if (module && module.parent) return ""; // Server-code
    if (!crypto || !crypto.subtle || !crypto.subtle.digest) { return "" }
    let cfg;
    if (req && req.session && req.session.user) { cfg = req.session }
    else { const globalState = window.getState(); cfg = {...globalState.cfg, lng: window.$("html").attr("lang"), theme: window.$("html").attr("data-theme")} }
    if (!cfg || !cfg.userip || !cfg.lng || !cfg.theme) { return "" }
    const str = "o" + ((cfg.user && cfg.user.login && cfg.user.login.slice(1)) || "") + "rS-e2" + cfg.userip.replace((/\./ig), "") + "v.u" + cfg.lng + "12s" + cfg.theme + "a64" + (rz.dateToString(new Date(), "DD.MM.YYYY")).replace((/\./ig), "") + ".";
    const txtEncoder = new TextEncoder(), encStr = txtEncoder.encode(str);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encStr);
    const hashArray = new Uint8Array(hashBuffer);
    // @ts-ignore
    const keyBase64 = btoa(String.fromCharCode(...hashArray));
    return keyBase64;
  },

  // @ts-ignore
  encryptData: async (data, key) => {
    // Binary format output: [IV: 16 bytes][encrypted_data: N bytes]
    // @ts-ignore
    if ((module && module.parent) || !data || !key) return new ArrayBuffer(0); // Server-code
    if (!data || !key) return new ArrayBuffer(0);

    const decodeBase64 = (str) => {
      if (!rz.isString(str)) { throw new Error("Crypto Error: Base64 value must be a string") }
      const normalized = str.replace((/\s+/g), "").replace((/-/g), "+").replace((/_/g), "/");
      const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
      return Uint8Array.from(atob(padded), (c) => (c.charCodeAt(0)));
    };

    let cryptoKey;
    try {
      const keyBuffer = decodeBase64(key);
      cryptoKey = await crypto.subtle.importKey("raw", keyBuffer, { name: "AES-CBC", length: 256 }, false, ["encrypt"]);
    } catch (err) {
      console.log(err);
      return new ArrayBuffer(0);
    }

    const iv = crypto.getRandomValues(new Uint8Array(16));
    let encrypted;
    try {
      const jsonData = rz.objToJSON(data);
      const payload = String(jsonData || "");
      const payloadHashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(payload));
      const payloadHash = Array.from(new Uint8Array(payloadHashBuffer)).map((b) => (b.toString(16).padStart(2, "0"))).join("");
      const packedPayload = `v1:${payloadHash}:${payload}`;
      encrypted = await crypto.subtle.encrypt({ name: "AES-CBC", iv }, cryptoKey, new TextEncoder().encode(packedPayload));
    } catch (err) {
      console.log(err);
      return new ArrayBuffer(0);
    }

    // Combine IV + encrypted data into single binary buffer
    const result = new Uint8Array(iv.length + encrypted.byteLength);
    result.set(iv, 0);
    result.set(new Uint8Array(encrypted), iv.length);
    return result.buffer;
  },

  decryptData: async (encryptedBuffer, key) => {
    // Binary format input: [IV: 16 bytes][encrypted_data: N bytes]
    // @ts-ignore
    if (module && module.parent) return {result: false, err: "rz.decryptData() works only at Client-side! Use sf.decryptData() instead"}; // Server-code
    if (!encryptedBuffer || !key) { return {data: "", result: false} }

    const decodeBase64 = (str) => {
      if (!rz.isString(str)) { throw new Error("Crypto Error: Base64 value must be a string") }
      const normalized = str.replace((/\s+/g), "").replace((/-/g), "+").replace((/_/g), "/");
      const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
      return Uint8Array.from(atob(padded), (c) => (c.charCodeAt(0)));
    };

    /** @type {any} */
    let buffer = encryptedBuffer;

    // Legacy JSON envelope support: {iv, data} in base64.
    if (rz.isObject(buffer) && buffer.iv && buffer.data) {
      try {
        const ivBytes = decodeBase64(String(buffer.iv));
        const dataBytes = decodeBase64(String(buffer.data));
        const merged = new Uint8Array(ivBytes.length + dataBytes.length);
        merged.set(ivBytes, 0);
        merged.set(dataBytes, ivBytes.length);
        buffer = merged;
      } catch (err) {
        console.log(err);
        return {result: false, err: "Crypto Error: Invalid legacy encrypted envelope"};
      }
    }

    // Convert ArrayBuffer if needed
    if (!(buffer instanceof Uint8Array) && buffer instanceof ArrayBuffer) {
      buffer = new Uint8Array(buffer);
    }
    if (!(buffer instanceof Uint8Array)) {
      console.log("Invalid buffer type");
      return {result: false, err: "Crypto Error: Invalid encrypted data type"};
    }
    if (buffer.length < 16) {
      return {result: false, err: "Crypto Error: Invalid encrypted data: too short"};
    }

    let cryptoKey;
    try {
      const keyData = decodeBase64(key);
      cryptoKey = await crypto.subtle.importKey("raw", keyData, {name: "AES-CBC", length: 256}, false, ["decrypt"]);
    } catch (err) {
      console.log(err);
      return {result: false, err: "Crypto Error: " + rz.errToString(err)};
    }

    const iv = buffer.subarray(0, 16);
    const encryptedData = buffer.subarray(16);

    let decrypted;
    try {
      decrypted = await crypto.subtle.decrypt({ name: "AES-CBC", iv }, cryptoKey, encryptedData);
    } catch (err) {
      console.log(err);
      return {result: false, err: "Crypto Error: " + rz.errToString(err)};
    }

    let data;
    try {
      let jsonStr = "";
      try {
        jsonStr = new TextDecoder("utf-8", {fatal: true}).decode(decrypted);
      } catch (errUtf8) {
        console.log(errUtf8);
        return {result: false, err: "Crypto Error: Invalid UTF-8 payload"};
      }

      // Verify payload integrity for v1 envelope: v1:<sha256_hex>:<payload>
      if (jsonStr.startsWith("v1:")) {
        const secondColon = jsonStr.indexOf(":", 3);
        if (secondColon <= 3) {
          return {result: false, err: "Crypto Error: Invalid encrypted envelope"};
        }
        const hashHex = jsonStr.slice(3, secondColon);
        const payload = jsonStr.slice(secondColon + 1);
        if (!(/^[0-9a-f]{64}$/).test(hashHex)) {
          return {result: false, err: "Crypto Error: Invalid payload hash"};
        }
        const actualHashBuffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(payload));
        const actualHashHex = Array.from(new Uint8Array(actualHashBuffer)).map((b) => (b.toString(16).padStart(2, "0"))).join("");
        if (actualHashHex !== hashHex) {
          return {result: false, err: "Crypto Error: Payload integrity check failed"};
        }
        jsonStr = payload;
      }

      // @ts-ignore
      data = (rz.isString(jsonStr) && (jsonStr.startsWith("{") || jsonStr.startsWith("["))) ? rz.objFromJSON(jsonStr) : jsonStr;
    } catch (err) {
      console.log(err);
      return {result: false, err: "Crypto Error: Can't parse decrypted data"};
    }

    return {data, result: Boolean(data)};
  },

  // @ts-ignore
  getCookieValue: (name) => {
    // @ts-ignore
    if (module && module.parent) return ""; // Only for Client-side
    const value = `; ${document.cookie}`;
    const parts = (value && value.split(`; ${name}=`)) || [];
    // @ts-ignore
    if (parts && parts.length === 2) { return (parts.pop().split(";").shift()) }
    return "";
  },

  fetchDB: ({appkey, database, operation, params, site}) => new Promise((resolve) => {
    if (!operation || !appkey || !database) { return resolve({result: false, err: "Some required arguments are missing: 'appkey', 'database', 'operation'", data: []}) }
    if (!~["read", "edit", "create", "delete"].indexOf(operation)) { return resolve({result: false, err: "Argument operation must be one of: 'read', 'edit', 'create', 'delete'", data: []}) }
    rz.getCryptoKey().then(async (key) => {
      if (!key) { return resolve({result: false, err: "Invalid Crypto Key", data: []}) }
      // Encrypt and send as binary
      /** @type {any} */
      const encryptedBuffer = await rz.encryptData(rz.objToJSON({appkey, database, operation, params, site}), key);
      // @ts-ignore
      fetch((site || "") + "/ui/db" + operation, {
        method: "POST",
        body: encryptedBuffer,
        headers: {"Content-Type": "application/octet-stream"}
      }).then(async (res) => {
        const cntType = (res.headers.get("content-type") || "").toLowerCase();
        if (~cntType.indexOf("application/json")) {
          const ansJson = await res.json();
          if (ansJson && ansJson.iv && ansJson.data) {
            // @ts-ignore
            const ans2 = await rz.decryptData(ansJson, key);
            if (ans2.err === "Crypto Error: OperationError") {
              const {cfg} = window.getState(), dct = window["dict-app"][cfg.lng || "en"];
              ans2.err = dct.e.cryptoError1;
            }
            resolve({...ans2.data, err: ans2.err || (ans2.data && ans2.data.err) || ""});
            return;
          }
          resolve(ansJson || {result: false, err: "Empty JSON response", data: []});
          return;
        }

        const buffer = await res.arrayBuffer();
        // Decrypt binary response
        // @ts-ignore
        const ans2 = await rz.decryptData(buffer, key);
        if (ans2.err === "Crypto Error: OperationError") {
          const {cfg} = window.getState(), dct = window["dict-app"][cfg.lng || "en"];
          ans2.err = dct.e.cryptoError1;
        }
        resolve({...ans2.data, err: ans2.err || (ans2.data && ans2.data.err) || ""});
      }).catch((err) => { resolve({result: false, err: rz.errToString(err), data: []}) });
    });
  }),

  translate: (params) => new Promise((resolve) => {
    // @ts-ignore
    const prms = ((params.ru || params.en || params.tr) ? {ru: params.ru, en: params.en, tr: params.tr} : {text: params.text, from: params.from, to: params.to});
    fetch("/api/translate", {method: "POST", body: JSON.stringify(prms), headers: {"Content-Type": "application/json;charset=utf-8"}}).then((res) => res.json().then((ans) => {
      resolve(ans);
    })).catch((err) => { resolve({result: false, err: rz.errToString(err)}) });
  }),

  serverAction: ({appkey, action, params, site}) => new Promise((resolve) => {
    if (!action || !appkey) { return resolve({result: false, err: "Some required arguments are missing: 'appkey', 'action'", data: []}) }
    rz.getCryptoKey().then(async (key) => {
      if (!key) { return resolve({result: false, err: "Invalid Crypto Key", data: []}) }
      // Encrypt and send as binary
      /** @type {any} */
      const encryptedBuffer = await rz.encryptData(rz.objToJSON({appkey, action, params, site}), key);
      // @ts-ignore
      fetch((site || "") + "/ui/serveraction", {
        method: "POST",
        body: encryptedBuffer,
        headers: {"Content-Type": "application/octet-stream"}
      }).then(async (res) => {
        const cntType = (res.headers.get("content-type") || "").toLowerCase();
        if (~cntType.indexOf("application/json")) {
          const ansJson = await res.json();
          if (ansJson && ansJson.iv && ansJson.data) {
            // @ts-ignore
            const ans2 = await rz.decryptData(ansJson, key);
            if (ans2.err === "Crypto Error: OperationError") {
              const {cfg} = window.getState(), dct = window["dict-app"][cfg.lng || "en"];
              ans2.err = dct.e.cryptoError1;
            }
            resolve({...ans2.data, err: ans2.err || (ans2.data && ans2.data.err) || ""});
            return;
          }
          resolve(ansJson || {result: false, err: "Empty JSON response"});
          return;
        }

        const buffer = await res.arrayBuffer();
        // Decrypt binary response
        // @ts-ignore
        const ans2 = await rz.decryptData(buffer, key);
        if (ans2.err === "Crypto Error: OperationError") {
          const {cfg} = window.getState(), dct = window["dict-app"][cfg.lng || "en"];
          ans2.err = dct.e.cryptoError1;
        }
        resolve({...ans2.data, err: ans2.err || (ans2.data && ans2.data.err) || ""});
      }).catch((err) => { resolve({result: false, err: rz.errToString(err)}) });
    });
  }),

  getOUpath: (ouValue) => {
    // ouValue = "CN=Mail Silikatnaya All,OU=Groups,OU=Силикатная,OU=Accounts,DC=gescons,DC=ru"
    const oum = [], prm = (ouValue || "").split(",");
    for (let i = prm.length; i > 0; i--) {
      if (prm[i - 1].startsWith("OU=")) { oum.push(prm[i - 1].replace("OU=", "")) }
    }
    return oum.join("/");
  },
  setOUpath: (strPath, baseDN, objectName) => {
    const revPath = strPath.split("/").reverse();
    const ouPath = (objectName ? "CN=" + objectName + "," : "") + "OU=" + revPath.join(",OU=") + (baseDN ? "," + baseDN : "");
    return ouPath;
  },

  loadContentDynamically: (sources) => new Promise((resolve) => {
    // @ts-ignore
    if (module && module.parent) { // Server-code
      return resolve({result: false, err: "This function works only at Client-side"});
    }
    if (!sources || !rz.isArray(sources) || !sources[0] || !rz.isString(sources[0])) { return resolve({result: false, err: "Arg 'sources' must be an Array<string>"}) }

    const loadedScripts = []; // Already loaded scripts (to skip their if have already loaded)
    // @ts-ignore
    window.$("script").each((s, ss) => {
      // @ts-ignore
      const fname1 = (rz.strFileName(window.$(ss).attr("src"))).toLowerCase().trim();
      loadedScripts.push(fname1);
    });
    // @ts-ignore
    window.$("link[type='text/css']").each((s, ss) => {
      // @ts-ignore
      const fname2 = (rz.strFileName(window.$(ss).attr("href"))).toLowerCase().trim();
      loadedScripts.push(fname2);
    });
    const middlePromise1 = (scriptPaths) => new Promise((res1) => {
      let counter = 0, alreadyResolve = false, err = "";
      const scripts = [];
      scriptPaths.forEach(async (ph, h) => {
        if (!(/^https:\/\//igm).test(ph)) { // Prevent loading external scripts
          if (!rz.arrContains(loadedScripts, ph, true, true)) {
            setTimeout(() => {
              const ext = rz.strFileExtension(ph);
              if (ext === "js") {
                const script = document.createElement("script");
                script.src = ph;
                script.onload = () => {
                  scripts.push(ph);
                  counter++; if (counter === scriptPaths.length && !alreadyResolve) { alreadyResolve = true; res1({err, result: Boolean(!err), scripts}) }
                };
                script.onerror = (err1) => {
                  err = "Failed to load '" + ph + "'. " + rz.errToString(err1); console.log(err);
                  counter++; if (counter === scriptPaths.length && !alreadyResolve) { alreadyResolve = true; res1({err, result: Boolean(!err), scripts}) }
                };
                document.body.appendChild(script);
              }
              else if (ext === "css") {
                const tableStyles = document.createElement("link");
                tableStyles.rel = "stylesheet"; tableStyles.type = "text/css"; tableStyles.href = ph;
                tableStyles.onload = () => {
                  scripts.push(ph);
                  counter++; if (counter === scriptPaths.length && !alreadyResolve) { alreadyResolve = true; res1({err, result: Boolean(!err), scripts}) }
                };
                tableStyles.onerror = (err1) => {
                  err = "Failed to load '" + ph + "'. " + rz.errToString(err1); console.log(err);
                  counter++; if (counter === scriptPaths.length && !alreadyResolve) { alreadyResolve = true; res1({err, result: Boolean(!err), scripts}) }
                };
                // @ts-ignore
                document.body.insertBefore(tableStyles, window.$("#preloader"));
              }
            }, 200 * h);
          }
          else {
            // if (fnc.config?.isDev) console.log("Script '" + ph + "' has already been loaded");
            scripts.push(ph);
            // console.log({counter, lngth: scriptPaths.length, alreadyResolve, err, scripts});
            counter++; if (counter === scriptPaths.length && !alreadyResolve) { alreadyResolve = true; res1({err, result: Boolean(!err), scripts}) }
          }
        }
      });
    });

    middlePromise1(sources).then((ans) => { resolve(ans) });
  }),

  cascaderPath: ({allRows, rowData, method, keyField, parentField, titleField, excludeKey, lng}) => {
    const lng1 = lng || rz.detectLng(), method1 = method || "parentPathArray";
    const keyField1 = keyField || "tgr_key", parentField1 = parentField || "parent", titleField1 = titleField || "title";
    let rowData1;
    // @ts-ignore
    if (rz.isArray(rowData) && rowData[0] && (rz.isString(rowData[0]) || (rz.isArray(rowData[0]) && rz.isString(rowData[0][0])))) {
      // @ts-ignore
      rowData1 = (allRows || []).filter((rr) => (rz.arrContains(rowData.map((vv) => ((rz.isArray(vv) && vv[vv.length - 1]) || vv)), rr[keyField1])));
    }
    else if (rz.isString(rowData)) {
      rowData1 = (allRows || []).filter((rr) => (rr[keyField1] === rowData));
    }
    else {
      // @ts-ignore
      rowData1 = rowData || allRows || [];
    }

    const excludeKey1 = (rz.isUndefinedOrNull(excludeKey) && rz.isObject(rowData1) && rowData1[keyField1] ? excludeKey = rowData1[keyField1] : "");

    // Middle function:
    const unshiftParents = (rw, path, extractKeysOnly) => {
      if (rw && rw[parentField1] && rw[parentField1] !== rw[keyField1]) {
        const prow = (allRows || []).find((rr) => (rr[keyField1] === rw[parentField1]));
        if (prow) {
          if (extractKeysOnly) {
            path.unshift(prow[keyField1]);
          }
          else {
            path.unshift(titleField1 === keyField1 ? prow[keyField1] : rz.strFromSelectedLng({lng: lng1, en: prow[titleField1 + "_en"], ru: prow[titleField1 + "_ru"], tr: prow[titleField1 + "_tr"], def: prow[titleField1] || prow[keyField1]}));
          }
          unshiftParents(prow, path, extractKeysOnly);
        }
      }
    };

    // Middle function:
    const buildChildrenItems = (allRws) => {
      if (!allRws || !allRws.length) { return [] }
      const items = {}, roots = [];
      // Первый проход - создание словаря всех элементов
      allRws.forEach((item) => {
        if (!excludeKey1 || item[keyField1] !== excludeKey1) {
          items[item[keyField1]] = {
            [keyField1]: item[keyField1], value: item[keyField1], [parentField1]: item[parentField1],
            children: [], label: (titleField1 === keyField1 ? item[keyField1] : rz.strFromSelectedLng({lng: lng1, ru: item[titleField1 + "_ru"], en: item[titleField1 + "_en"], tr: item[titleField1 + "_tr"], def: item[titleField1] || item[keyField1]}))
          };
        }
      });
      // Второй проход - построение дерева
      allRws.forEach((item) => {
        if (item[parentField1]) {
          // Если у элемента есть родитель, добавляем его в children родителя
          if (items[item[parentField1]]) {
            if (items[item[keyField1]]) { items[item[parentField1]].children.push(items[item[keyField1]]) }
          } else {
            // Если родитель не найден, выводим предупреждение
            console.warn(`Parent ${item[parentField1]} not found for ${item[keyField1]}`);
          }
        } else if (items[item[keyField1]]) {
          roots.push(items[item[keyField1]]);
        }
      });
      return roots;
    };

    // Middle function:
    const treeToFlatArray = (allRws, rwData, lng2) => {
      const flatArray = [];
      const makeChildrenFlat = (chldrn) => {
        (chldrn || []).forEach((rr) => {
          if (!rwData || (rwData && keyField1 && (rr[keyField1] || rr.key || rr.value))) {
            flatArray.push({key: (rr[keyField1] || rr.key || rr.value), title: rz.strFromSelectedLng({lng: lng2, def: rr.title, ru: rr.title_ru, en: rr.title_en, tr: rr.title_tr})});
            if (rr.children && rr.children.length) { makeChildrenFlat(rr.children) }
          }
        });
      };
      // console.log({allRws, rwData, keyField1});
      (allRws || []).forEach((rr) => {
        if (
          !rwData
          || (rwData && keyField1 && (rr[keyField1] || rr.key || rr.value))
        ) {
          flatArray.push({key: (rr[keyField1] || rr.key || rr.value), title: rz.strFromSelectedLng({lng: lng2, def: rr.title, ru: rr.title_ru, en: rr.title_en, tr: rr.title_tr})});
          if (rr.children && rr.children.length) { makeChildrenFlat(rr.children) }
        }
      });
      return flatArray;
    };

    // Main action:
    if (method1 === "flatArrayToCascaderValue") {
      if (rz.isArray(rowData1)) {
        const ans = rowData1.map((rw) => {
          const path = [rw[keyField1]];
          unshiftParents(rw, path, true);
          return path;
        });
        return ans;
      }
      const path = [rowData1[keyField1]];
      unshiftParents(rowData1, path, true);
      return path;
    }

    if (~["pathArray", "pathString", "parentPathString", "parentPathArray"].indexOf(method1)) {
      if (rz.isArray(rowData1)) {
        const ans = rowData1.map((rw) => {
          const path = [titleField1 === keyField1 ? rw[keyField1] : rz.strFromSelectedLng({lng: lng1, en: rw[titleField1 + "_en"], ru: rw[titleField1 + "_ru"], tr: rw[titleField1 + "_tr"], def: rw[titleField1] || rw[keyField1]})];
          unshiftParents(rw, path);
          if (method1 === "pathString") { return path.join("/") }
          if (method1 === "parentPathArray") { path.pop(); return path }
          if (method1 === "parentPathString") { path.pop(); return path.join("/") }
          return path;
        });
        if (!ans.length) { return rowData1 }
        return rowData1.map((rr, r) => ({...rr, path: ans[r]}));
      }
      // else
      // eslint-disable-next-line max-len
      const path = [titleField1 === keyField1 ? rowData1[keyField1] : rz.strFromSelectedLng({lng: lng1, en: rowData1[titleField1 + "_en"], ru: rowData1[titleField1 + "_ru"], tr: rowData1[titleField1 + "_tr"], def: rowData1[titleField1] || rowData1[keyField1]})];
      unshiftParents(rowData1, path);
      if (method1 === "pathString") { return path.join("/") }
      if (method1 === "parentPathArray") { path.pop(); return path }
      if (method1 === "parentPathString") { path.pop(); return path.join("/") }
      return path;
    }

    if (method1 === "tree") {
      const tree = buildChildrenItems(allRows);
      return tree;
    }

    if (method1 === "treeToFlatArray") {
      const flatArr = treeToFlatArray(allRows, rowData1, lng1);
      return flatArr;
    }

    return undefined; // Error: unknown method
  },

  konturFocusBriefReport: (inn) => new Promise((resolve) => {
    fetch("/api/konturbriefreport?inn=" + inn).then((res) => res.json().then((ans) => {
      resolve(ans)
    // @ts-ignore
    })).catch((err) => { resolve({result: false, err: rz.errToString(err)}) });
  }),

  konturFocusMainRequisites: (inn) => new Promise((resolve) => {
    fetch("/api/konturmainrequisites?inn=" + inn).then((res) => res.json().then((ans) => {
      resolve(ans)
    // @ts-ignore
    })).catch((err) => { resolve({result: false, err: rz.errToString(err)}) });
  }),

  daDataGetGenerativeFIO: (fio) => new Promise((resolve) => {
    fetch("/api/dadatafio?fio=" + encodeURIComponent(fio)).then((res) => res.json().then((ans) => {
      resolve(ans)
    // @ts-ignore
    })).catch((err) => { resolve({result: "", err: rz.errToString(err)}) });
  }),

  dadataMainRequisites: (inn) => new Promise((resolve) => {
    fetch("/api/dadatamainrequisites?inn=" + inn).then((res) => res.json().then((ans) => {
      resolve(ans)
    // @ts-ignore
    })).catch((err) => { resolve({result: "", err: rz.errToString(err)}) });
  }),

  spExtractLookupIDs: (lkpValue) => {
    if (!lkpValue || !lkpValue.$M_1 || !lkpValue.$c_1) { return [] }
    const str = ";#" + lkpValue.$M_1 + ";#" + lkpValue.$c_1;
    const numbers = Array.from(str.matchAll(/;#(\d+);#/g), (aa) => (Number(aa[1])));
    return rz.arrGetUnique(numbers, true);
  },

  spExtractLookupObjects: (lkpValue) => {
    if (!lkpValue || !lkpValue.$M_1 || !lkpValue.$c_1) { return [] }
    const str = ";#" + lkpValue.$M_1 + ";#" + lkpValue.$c_1;
    const vv = Array.from(str.matchAll(/;#(\d+);#/g), (aa) => ({id: Number(aa[1]), text: (aa[2] || "").trim()}));
    return vv;
  }
};

module.exports = rz;
